import { MouseEvent, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Help } from "@mui/icons-material";
import { Box as MuiBox } from "@mui/material";

import { Alert, Button } from "@dzambalaorg/ui-kit";

import { StyledPopover } from "./styled";

export const AllowanceInfoPopover = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handlePopoverOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <MuiBox>
      <Button
        intent="icon"
        aria-owns={open ? "allowance-info" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <Help />
      </Button>
      <StyledPopover
        id={"allowance-info"}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableRestoreFocus
      >
        <Alert severity="warning">
          <FormattedMessage id="alert.approve" />
        </Alert>
      </StyledPopover>
    </MuiBox>
  );
};
